/* ════════════════════════════════════════════════════════════════
   대한민국 중·고등학교 수학 교육과정 목차 — 단일 출처(single source of truth)
   · 중학교: 2022 개정 교육과정 (2025~ 중1부터 순차 적용, 대단원 구성은 현행 교과서 기준)
   · 고등학교(고1·고2): 2022 개정 — 공통수학1·2, 대수, 미적분Ⅰ·Ⅱ, 확률과 통계, 기하
   · 고3(수능): 2015 개정 — 수학Ⅰ·Ⅱ, 확률과 통계, 미적분, 기하
   ⚠️ chapter.name(대단원)은 knowledgeGraph.js 노드 이름과 1:1 매칭됨 — 바꾸면 안 됨.
   구조: LEVELS[] → subjects[] → chapters[{name, topics[]}]
   호환: CURRICULUM(옛 Academy 형식 {level,subjects:[{id,name,units[]}]})도 함께 export.
════════════════════════════════════════════════════════════════ */

/* ── 중학교 ── */
const M1=[
  {name:"소인수분해",topics:["소수와 합성수","거듭제곱","소인수분해","소인수분해를 이용한 약수 구하기","최대공약수와 서로소","최소공배수","최대공약수·최소공배수의 활용"]},
  {name:"정수와 유리수",topics:["양수와 음수","정수와 유리수의 뜻","수직선과 절댓값","수의 대소 관계","정수와 유리수의 덧셈·뺄셈","정수와 유리수의 곱셈·나눗셈","사칙 혼합 계산"]},
  {name:"문자의 사용과 식의 계산",topics:["문자를 사용한 식","곱셈·나눗셈 기호의 생략","대입과 식의 값","항·계수·차수","동류항의 계산","일차식의 덧셈과 뺄셈"]},
  {name:"일차방정식",topics:["등식·방정식·항등식","등식의 성질","이항과 일차방정식의 뜻","일차방정식의 풀이","계수가 소수·분수인 일차방정식","일차방정식의 활용(수·나이·거리속력시간)"]},
  {name:"좌표평면과 그래프(정비례·반비례)",topics:["순서쌍과 좌표","사분면","그래프의 뜻과 해석","정비례 관계와 그 그래프","반비례 관계와 그 그래프"]},
  {name:"기본 도형",topics:["점·선·면과 교점·교선","직선·반직선·선분","각의 뜻과 분류","맞꼭지각","수직과 수선","점·직선·평면의 위치 관계","동위각과 엇각","평행선의 성질"]},
  {name:"작도와 합동",topics:["간단한 도형의 작도","삼각형의 작도","삼각형이 하나로 정해지는 조건","도형의 합동과 대응","삼각형의 합동 조건(SSS·SAS·ASA)"]},
  {name:"평면도형의 성질",topics:["다각형과 대각선","삼각형의 내각과 외각","다각형의 내각·외각의 크기의 합","원과 부채꼴","부채꼴의 호의 길이와 넓이"]},
  {name:"입체도형의 성질",topics:["다면체","정다면체","회전체","기둥의 겉넓이와 부피","뿔의 겉넓이와 부피","구의 겉넓이와 부피"]},
  {name:"자료의 정리와 해석",topics:["줄기와 잎 그림","도수분포표","히스토그램과 도수분포다각형","상대도수와 그 그래프"]},
];
const M2=[
  {name:"유리수와 순환소수",topics:["유한소수와 무한소수","순환소수와 순환마디","유한소수로 나타낼 수 있는 분수","순환소수를 분수로 나타내기"]},
  {name:"단항식과 다항식의 계산",topics:["지수법칙","단항식의 곱셈과 나눗셈","다항식의 덧셈과 뺄셈","단항식과 다항식의 곱셈·나눗셈(전개)"]},
  {name:"일차부등식",topics:["부등식의 뜻과 성질","일차부등식의 풀이","복잡한 일차부등식","일차부등식의 활용"]},
  {name:"연립일차방정식",topics:["미지수가 2개인 일차방정식","연립방정식의 뜻과 해","대입법","가감법","여러 가지 연립방정식","연립방정식의 활용"]},
  {name:"일차함수와 그래프",topics:["함수와 함숫값","일차함수의 뜻","일차함수의 그래프와 평행이동","x절편과 y절편","기울기","일차함수의 식 구하기","일차함수의 활용"]},
  {name:"일차함수와 일차방정식",topics:["일차함수와 일차방정식의 관계","직선 x=p, y=q","연립방정식의 해와 두 직선의 교점","두 직선의 위치 관계와 해의 개수"]},
  {name:"삼각형의 성질",topics:["이등변삼각형의 성질","이등변삼각형이 되는 조건","직각삼각형의 합동 조건(RHA·RHS)","삼각형의 외심","삼각형의 내심"]},
  {name:"사각형의 성질",topics:["평행사변형의 성질","평행사변형이 되는 조건","직사각형·마름모·정사각형","사다리꼴","여러 가지 사각형 사이의 관계"]},
  {name:"도형의 닮음",topics:["닮은 도형과 닮음비","삼각형의 닮음 조건","평행선 사이의 선분의 길이의 비","삼각형의 중점연결정리","닮은 도형의 넓이의 비와 부피의 비","닮음의 활용"]},
  {name:"피타고라스 정리",topics:["피타고라스 정리와 증명","피타고라스 정리의 역","평면도형·입체도형에서의 활용"]},
  {name:"경우의 수와 확률",topics:["사건과 경우의 수","합의 법칙과 곱의 법칙","확률의 뜻과 성질","확률의 덧셈과 곱셈","여러 가지 확률의 계산"]},
];
const M3=[
  {name:"제곱근과 실수",topics:["제곱근의 뜻과 표현","제곱근의 성질","무리수와 실수","실수의 대소 관계","제곱근의 곱셈과 나눗셈","분모의 유리화","제곱근의 덧셈과 뺄셈"]},
  {name:"다항식의 곱셈과 인수분해",topics:["곱셈 공식","곱셈 공식의 활용","인수분해의 뜻","인수분해 공식","복잡한 식의 인수분해","인수분해의 활용"]},
  {name:"이차방정식",topics:["이차방정식의 뜻과 해","인수분해를 이용한 풀이","완전제곱식을 이용한 풀이","근의 공식","이차방정식의 근의 개수","이차방정식의 활용"]},
  {name:"이차함수",topics:["이차함수의 뜻","y=ax²의 그래프","y=a(x-p)²+q의 그래프","y=ax²+bx+c의 그래프","이차함수의 최댓값과 최솟값"]},
  {name:"삼각비",topics:["삼각비의 뜻(sin·cos·tan)","특수각의 삼각비","예각의 삼각비의 값","삼각비의 활용(길이)","삼각비의 활용(넓이)"]},
  {name:"원의 성질",topics:["원의 중심과 현","현의 수직이등분선","원의 접선의 성질","원주각과 중심각","원주각의 성질","네 점이 한 원 위에 있을 조건","접선과 현이 이루는 각"]},
  {name:"대푯값과 산포도",topics:["평균·중앙값·최빈값","편차와 분산","표준편차","산점도","상관관계"]},
];

/* ── 고등학교 · 2022 개정 (공통) ── */
const CM1=[
  {name:"다항식의 연산",topics:["다항식의 덧셈과 뺄셈","다항식의 곱셈과 곱셈 공식","곱셈 공식의 변형","다항식의 나눗셈","조립제법"]},
  {name:"나머지정리와 인수분해",topics:["항등식과 미정계수법","나머지정리","인수정리","인수분해 공식","복잡한 식·고차식의 인수분해"]},
  {name:"복소수와 이차방정식",topics:["복소수의 뜻","복소수의 사칙연산","켤레복소수","i의 거듭제곱과 음수의 제곱근","이차방정식의 판별식","근과 계수의 관계","켤레근의 성질"]},
  {name:"이차방정식과 이차함수",topics:["이차함수의 그래프와 이차방정식의 근","이차함수의 그래프와 직선의 위치 관계","이차함수의 최대·최소","제한된 범위에서의 최대·최소"]},
  {name:"여러 가지 방정식",topics:["삼차방정식과 사차방정식","삼차방정식의 근과 계수의 관계","연립이차방정식","부정방정식"]},
  {name:"여러 가지 부등식",topics:["연립일차부등식","절댓값을 포함한 부등식","이차부등식","이차부등식의 활용(판별식)","연립이차부등식"]},
  {name:"순열과 조합",topics:["합의 법칙과 곱의 법칙","순열의 뜻과 계산","조합의 뜻과 계산","순열·조합의 활용"]},
  {name:"행렬과 그 연산",topics:["행렬의 뜻과 성분","행렬의 덧셈·뺄셈과 실수배","행렬의 곱셈","행렬 곱셈의 성질(교환법칙 불성립)"]},
];
const CM2=[
  {name:"평면좌표와 직선의 방정식",topics:["두 점 사이의 거리","선분의 내분점","직선의 방정식","두 직선의 평행과 수직","점과 직선 사이의 거리"]},
  {name:"원의 방정식",topics:["원의 방정식","이차방정식 x²+y²+Ax+By+C=0","원과 직선의 위치 관계","원의 접선의 방정식"]},
  {name:"도형의 이동",topics:["점과 도형의 평행이동","x축·y축·원점에 대한 대칭이동","직선 y=x에 대한 대칭이동"]},
  {name:"집합",topics:["집합의 뜻과 표현","집합 사이의 포함 관계","교집합과 합집합","여집합과 차집합","집합의 연산 법칙과 드모르간 법칙","유한집합의 원소의 개수"]},
  {name:"명제",topics:["명제와 조건","명제의 참·거짓과 진리집합","명제의 역과 대우","충분조건·필요조건·필요충분조건","대우를 이용한 증명과 귀류법","절대부등식"]},
  {name:"함수",topics:["함수의 뜻과 그래프","일대일함수와 일대일대응","합성함수","역함수와 그 그래프"]},
  {name:"유리함수와 무리함수",topics:["유리식과 유리함수","유리함수의 그래프와 점근선","무리식과 무리함수","무리함수의 그래프"]},
];

/* ── 대수(2022) ≡ 수학Ⅰ(2015) — 대단원 이름은 지식그래프(s1_*)와 동일 ── */
const ALG=[
  {name:"지수와 로그",topics:["거듭제곱근의 뜻과 성질","지수의 확장(정수·유리수·실수)","로그의 뜻과 성질","로그의 밑 변환","상용로그"]},
  {name:"지수함수와 로그함수",topics:["지수함수의 뜻과 그래프","로그함수의 뜻과 그래프","지수함수·로그함수의 최대·최소","지수방정식과 지수부등식","로그방정식과 로그부등식"]},
  {name:"삼각함수",topics:["일반각과 호도법","삼각함수의 뜻","삼각함수 사이의 관계","삼각함수의 그래프와 주기","삼각방정식과 삼각부등식"]},
  {name:"사인법칙과 코사인법칙",topics:["사인법칙","코사인법칙","삼각형의 넓이"]},
  {name:"등차수열과 등비수열",topics:["수열의 뜻","등차수열의 일반항","등차수열의 합","등비수열의 일반항","등비수열의 합"]},
  {name:"수열의 합",topics:["합의 기호 Σ의 뜻과 성질","자연수의 거듭제곱의 합","여러 가지 수열의 합(부분분수·근호)"]},
  {name:"수학적 귀납법",topics:["수열의 귀납적 정의(점화식)","수학적 귀납법에 의한 증명"]},
];
/* ── 미적분Ⅰ(2022) ≡ 수학Ⅱ(2015) — 대단원 이름은 지식그래프(s2_*)와 동일 ── */
const CALC1=[
  {name:"함수의 극한",topics:["함수의 극한의 뜻","좌극한과 우극한","극한값의 계산","미정계수의 결정","함수의 극한의 대소 관계"]},
  {name:"함수의 연속",topics:["함수의 연속의 뜻","연속함수의 성질","최대·최소 정리","사잇값 정리"]},
  {name:"미분계수와 도함수",topics:["평균변화율과 미분계수","미분가능성과 연속성","도함수의 뜻","미분법의 공식(합·차·곱)"]},
  {name:"도함수의 활용",topics:["접선의 방정식","평균값 정리","함수의 증가와 감소","함수의 극대와 극소","함수의 그래프 개형","함수의 최대·최소","방정식과 부등식에의 활용","속도와 가속도"]},
  {name:"부정적분",topics:["부정적분의 뜻","부정적분의 계산"]},
  {name:"정적분",topics:["구분구적법과 정적분의 뜻","미적분의 기본정리","정적분의 계산과 성질"]},
  {name:"정적분의 활용",topics:["곡선과 좌표축 사이의 넓이","두 곡선 사이의 넓이","속도와 거리"]},
];
/* ── 확률과 통계 — 2022·2015 공통 골격 (차이는 토픽에 표기) ── */
const PROB=[
  {name:"여러 가지 순열",topics:["원순열","중복순열","같은 것이 있는 순열"]},
  {name:"중복조합과 이항정리",topics:["중복조합","이항정리","이항계수의 성질과 파스칼의 삼각형"]},
  {name:"확률의 뜻과 활용",topics:["시행과 사건","수학적 확률과 통계적 확률","확률의 기본 성질","확률의 덧셈정리","여사건의 확률"]},
  {name:"조건부확률",topics:["조건부확률의 뜻","확률의 곱셈정리","사건의 독립과 종속","독립시행의 확률"]},
  {name:"이산확률변수의 확률분포",topics:["확률변수와 확률분포","이산확률변수의 기댓값(평균)","분산과 표준편차","이항분포"]},
  {name:"연속확률변수와 정규분포",topics:["연속확률변수와 확률밀도함수","정규분포","표준정규분포와 표준화","이항분포와 정규분포의 관계"]},
  {name:"통계적 추정",topics:["모집단과 표본, 임의추출","표본평균의 분포","모평균의 추정과 신뢰구간","모비율의 추정(2022 개정)"]},
];
/* ── 미적분Ⅱ(2022) ≡ 미적분(2015) ── */
const CALC2=[
  {name:"수열의 극한",topics:["수열의 수렴과 발산","수열의 극한값의 계산","등비수열의 극한"]},
  {name:"급수",topics:["급수의 수렴과 발산","등비급수","등비급수의 활용"]},
  {name:"여러 가지 함수의 미분",topics:["지수함수와 로그함수의 극한","무리수 e와 자연로그","지수함수·로그함수의 미분","삼각함수의 덧셈정리","삼각함수의 극한과 미분"]},
  {name:"여러 가지 미분법",topics:["함수의 몫의 미분법","합성함수의 미분법","매개변수로 나타낸 함수의 미분법","음함수와 역함수의 미분법","이계도함수"]},
  {name:"도함수의 활용(미적분)",topics:["접선의 방정식","함수의 그래프 개형(변곡점)","방정식과 부등식에의 활용","속도와 가속도"]},
  {name:"여러 가지 적분법",topics:["여러 가지 함수의 부정적분","치환적분법","부분적분법","정적분의 치환적분과 부분적분"]},
  {name:"정적분의 활용(미적분)",topics:["정적분과 급수의 합 사이의 관계","넓이","부피","속도와 거리"]},
];
/* ── 기하 — 2022·2015 공통 골격 (공간벡터는 2022) ── */
const GEO=[
  {name:"이차곡선",topics:["포물선의 뜻과 방정식","타원의 뜻과 방정식","쌍곡선의 뜻과 방정식","이차곡선과 직선(접선의 방정식)"]},
  {name:"평면벡터",topics:["벡터의 뜻","벡터의 덧셈·뺄셈·실수배","위치벡터와 성분 표현","평면벡터의 내적","직선과 원의 벡터에 의한 표현"]},
  {name:"공간도형",topics:["직선과 평면의 위치 관계","직선과 평면의 평행·수직","삼수선의 정리","정사영"]},
  {name:"공간좌표",topics:["공간에서의 점의 좌표","두 점 사이의 거리와 내분점","구의 방정식"]},
];
const GEO22=[...GEO,
  {name:"공간벡터(2022)",topics:["공간벡터의 뜻과 연산","공간벡터의 성분과 내적"]},
];

/* ── 트랙(학년군) → 과목 ──
   id는 knowledgeGraph.js COURSES와 일치(m1~s2). 새 과목은 새 id. */
const LEVELS=[
  {level:"중등 수학",levelId:"middle",subjects:[
    {id:"m1",name:"중1 수학",chapters:M1},
    {id:"m2",name:"중2 수학",chapters:M2},
    {id:"m3",name:"중3 수학",chapters:M3},
  ]},
  {level:"고등 수학 · 2022 개정 (고1·고2)",levelId:"high22",subjects:[
    {id:"cm1",name:"공통수학1",chapters:CM1},
    {id:"cm2",name:"공통수학2",chapters:CM2},
    {id:"alg",name:"대수",chapters:ALG},
    {id:"calc1",name:"미적분Ⅰ",chapters:CALC1},
    {id:"prob",name:"확률과 통계",chapters:PROB},
    {id:"calc2",name:"미적분Ⅱ",chapters:CALC2},
    {id:"geo",name:"기하",chapters:GEO22},
  ]},
  {level:"고3 · 수능 (2015 개정)",levelId:"high15",subjects:[
    {id:"s1",name:"수학Ⅰ",chapters:ALG},
    {id:"s2",name:"수학Ⅱ",chapters:CALC1},
    {id:"prob15",name:"확률과 통계(고3)",chapters:PROB},
    {id:"calc15",name:"미적분(고3)",chapters:CALC2},
    {id:"geo15",name:"기하(고3)",chapters:GEO},
  ]},
];

/* ── 호환용: 옛 Academy 형식 (units = 대단원 이름 배열) ── */
const CURRICULUM=LEVELS.map(lv=>({level:lv.level,subjects:lv.subjects.map(s=>({id:s.id,name:s.name,units:s.chapters.map(c=>c.name)}))}));

/* 과목 찾기 헬퍼 */
function findSubject(id){for(const lv of LEVELS)for(const s of lv.subjects)if(s.id===id)return s;return null;}

export { LEVELS, CURRICULUM, findSubject };
